module.exports = __webpack_public_path__ + "svg/chevron-left-thick.524f1ba888e0ac18c18d8510499fdb63.svg";